import uvMarbleGold from "@/assets/products/uv-marble-gold.jpg";
import uvMarbleWhite from "@/assets/products/uv-marble-white.jpg";
import uvMarbleBlack from "@/assets/products/uv-marble-black.jpg";
import uvMarbleTravertineGrey from "@/assets/products/uv-marble-travertine-grey.jpg";
import uvMarbleLightStone from "@/assets/products/uv-marble-light-stone.jpg";
import uvMarbleAlpineGoldVein from "@/assets/products/uv-marble-alpine-gold-vein.jpg";
import uvMarbleIndianAutumn from "@/assets/products/uv-marble-indian-autumn.jpg";
import uvMarbleBlueGold from "@/assets/products/uv-marble-blue-gold.jpg";
import uvMarbleWhiteBrown from "@/assets/products/uv-marble-white-brown.jpg";
import uvMarbleBeige from "@/assets/products/uv-marble-beige.jpg";
import uvMarbleTravertineStone from "@/assets/products/uv-marble-travertine-stone.png";
import uvMarbleArcticDriftAsset from "@/assets/products/uv-marble-arctic-drift.webp.asset.json";
import uvMarbleTravertineGoldAsset from "@/assets/products/uv-marble-travertine-gold.webp.asset.json";
import uvMarbleGreenCanyonAsset from "@/assets/products/uv-marble-green-canyon.webp.asset.json";
import uvMarbleMoonstoneAsset from "@/assets/products/uv-marble-moonstone.webp.asset.json";

import uvMarbleGoldInstalled from "@/assets/products/uv-marble-gold-installed.jpg";
import uvMarbleWhiteInstalled from "@/assets/products/uv-marble-white-installed.png";
import uvMarbleBlackInstalled from "@/assets/products/uv-marble-black-installed.jpg";
import uvMarbleTravertineGreyInstalled from "@/assets/products/uv-marble-travertine-grey-installed.png";
import uvMarbleLightStoneInstalled from "@/assets/products/uv-marble-light-stone-installed.jpg";
import uvMarbleAlpineGoldVeinInstalled from "@/assets/products/uv-marble-alpine-gold-vein-installed.jpg";
import uvMarbleIndianAutumnInstalled from "@/assets/products/uv-marble-indian-autumn-installed.jpg";
import uvMarbleBlueGoldInstalled from "@/assets/products/uv-marble-blue-gold-installed.jpg";
import uvMarbleWhiteBrownInstalled from "@/assets/products/uv-marble-white-brown-installed.jpg";
import uvMarbleBeigeInstalled from "@/assets/products/uv-marble-beige-installed.png";

export interface UVMarbleSheetProduct {
  id: string;
  name: string;
  colour: string;
  description: string;
  price: number;
  image: string;
  installedImage?: string;
  size: string;
  thickness: string;
  shopifyVariantId?: string;
  imageAlt?: string;
  qldOnly?: boolean;
  soldOut?: boolean;
}

const assetUrl = (url: string) => `https://supremeturf.com.au${url}`;

export function uvMarbleVariantId(product: UVMarbleSheetProduct): string {
  return product.shopifyVariantId ?? `local-uv-marble-variant-${product.id}`;
}

export const UV_MARBLE_SHEET_PRODUCTS: UVMarbleSheetProduct[] = [
  {
    id: "uv-marble-arctic-drift",
    name: "Arctic Drift",
    colour: "Arctic Drift",
    description: "Premium white and grey marble-look UV sheet with natural stone movement, ideal for luxury feature walls and modern interiors.",
    price: 85,
    image: assetUrl(uvMarbleArcticDriftAsset.url),
    imageAlt: "Arctic Drift UV Marble Sheet Queensland",
    size: "1.2m × 2.7m",
    thickness: "3mm",
    qldOnly: true,
  },
  {
    id: "uv-marble-travertine-gold",
    name: "Travertine Gold",
    colour: "Travertine Gold",
    description: "Elegant grey marble-look UV sheet with subtle gold veining, designed for stylish residential and commercial interiors.",
    price: 85,
    image: assetUrl(uvMarbleTravertineGoldAsset.url),
    imageAlt: "Travertine Gold UV Marble Sheet Queensland",
    size: "1.2m × 2.7m",
    thickness: "3mm",
    qldOnly: true,
  },
  {
    id: "uv-marble-green-canyon",
    name: "Green Canyon",
    colour: "Green Canyon",
    description: "Luxury white marble-look UV sheet featuring bold natural stone patterns with black and gold accents.",
    price: 85,
    image: assetUrl(uvMarbleGreenCanyonAsset.url),
    imageAlt: "Green Canyon UV Marble Sheet Queensland",
    size: "1.2m × 2.7m",
    thickness: "3mm",
    qldOnly: true,
  },
  {
    id: "uv-marble-moonstone",
    name: "Moonstone",
    colour: "Moonstone",
    description: "Modern white marble-look UV sheet with dramatic dark stone details and premium luxury styling.",
    price: 85,
    image: assetUrl(uvMarbleMoonstoneAsset.url),
    imageAlt: "Moonstone UV Marble Sheet Queensland",
    size: "1.2m × 2.7m",
    thickness: "3mm",
    qldOnly: true,
  },
  {
    id: "uv-marble-gold",
    name: "Gold Marble",
    colour: "Gold Marble",
    description: "Luxurious gold-veined marble finish for elegant feature walls.",
    price: 85,
    image: uvMarbleGold,
    installedImage: uvMarbleGoldInstalled,
    size: "1.2m × 2.7m",
    thickness: "3mm",
    shopifyVariantId: "gid://shopify/ProductVariant/47838612259057",
  },
  {
    id: "uv-marble-white",
    name: "White Marble",
    colour: "White Marble",
    description: "Classic pure white marble finish for timeless interiors.",
    price: 85,
    image: uvMarbleWhite,
    installedImage: uvMarbleWhiteInstalled,
    size: "1.2m × 2.7m",
    thickness: "3mm",
    shopifyVariantId: "gid://shopify/ProductVariant/47838613569777",
  },
  {
    id: "uv-marble-black",
    name: "Black Marble",
    colour: "Black Marble",
    description: "Bold black marble with striking white veins for dramatic interiors.",
    price: 85,
    image: uvMarbleBlack,
    installedImage: uvMarbleBlackInstalled,
    size: "1.2m × 2.7m",
    thickness: "3mm",
    shopifyVariantId: "gid://shopify/ProductVariant/47838615306481",
  },
  {
    id: "uv-marble-travertine-grey",
    name: "Travertine Grey",
    colour: "Travertine Grey",
    description: "Natural grey travertine look for sophisticated modern spaces.",
    price: 85,
    image: uvMarbleTravertineGrey,
    installedImage: uvMarbleTravertineGreyInstalled,
    size: "1.2m × 2.7m",
    thickness: "3mm",
    shopifyVariantId: "gid://shopify/ProductVariant/47838616191217",
  },
  {
    id: "uv-marble-light-stone",
    name: "Light Stone",
    colour: "Light Stone",
    description: "Subtle light stone texture for a natural, understated wall finish.",
    price: 85,
    image: uvMarbleLightStone,
    installedImage: uvMarbleLightStoneInstalled,
    size: "1.2m × 2.7m",
    thickness: "3mm",
    shopifyVariantId: "gid://shopify/ProductVariant/47838616223985",
  },
  {
    id: "uv-marble-alpine-gold-vein",
    name: "Alpine Gold Vein",
    colour: "Alpine Gold Vein",
    description: "White marble with delicate gold veining for a premium aesthetic.",
    price: 85,
    image: uvMarbleAlpineGoldVein,
    installedImage: uvMarbleAlpineGoldVeinInstalled,
    size: "1.2m × 2.7m",
    thickness: "3mm",
    shopifyVariantId: "gid://shopify/ProductVariant/47838617043185",
  },
  {
    id: "uv-marble-indian-autumn",
    name: "Indian Autumn",
    colour: "Indian Autumn",
    description: "Warm earthy tones inspired by natural sandstone and autumn hues.",
    price: 85,
    image: uvMarbleIndianAutumn,
    installedImage: uvMarbleIndianAutumnInstalled,
    size: "1.2m × 2.7m",
    thickness: "3mm",
    shopifyVariantId: "gid://shopify/ProductVariant/47838619959537",
  },
  {
    id: "uv-marble-blue-gold",
    name: "Blue Gold",
    colour: "Blue Gold",
    description: "Stunning blue and gold swirls for a luxurious designer statement wall.",
    price: 85,
    image: uvMarbleBlueGold,
    installedImage: uvMarbleBlueGoldInstalled,
    size: "1.2m × 2.7m",
    thickness: "3mm",
    shopifyVariantId: "gid://shopify/ProductVariant/47838623236337",
  },
  {
    id: "uv-marble-white-brown",
    name: "White & Brown",
    colour: "White & Brown",
    description: "Warm white marble with brown veining for a soft, inviting look.",
    price: 85,
    image: uvMarbleWhiteBrown,
    installedImage: uvMarbleWhiteBrownInstalled,
    size: "1.2m × 2.7m",
    thickness: "3mm",
    shopifyVariantId: "gid://shopify/ProductVariant/47838628675825",
  },
  {
    id: "uv-marble-beige",
    name: "Beige",
    colour: "Beige",
    description: "Neutral beige stone finish perfect for contemporary living spaces.",
    price: 85,
    image: uvMarbleBeige,
    installedImage: uvMarbleBeigeInstalled,
    size: "1.2m × 2.7m",
    thickness: "3mm",
    shopifyVariantId: "gid://shopify/ProductVariant/47838630576369",
  },
  {
    id: "uv-marble-travertine-stone",
    name: "Travertine Stone",
    colour: "Travertine Stone",
    description: "Soft grey travertine stone finish with natural veining for a refined, contemporary wall.",
    price: 85,
    image: uvMarbleTravertineStone,
    size: "1.2m × 2.7m",
    thickness: "3mm",
    shopifyVariantId: "gid://shopify/ProductVariant/47838630576370",
  },
];
